/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { POOLINFO } from '../model/pOOLINFO';
import { PoolObjectSubset } from '../model/poolObjectSubset';
import { RESPONSEITEM } from '../model/rESPONSEITEM';
import { SMDPPROFILE } from '../model/sMDPPROFILE';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PoolsService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * List of pools getting operation. This is the operation to get a list of pools managed by the authenticated account
     * @param offset An offset for a list (required for pagination)
     * @param limit A maximum number of entries returned by the request
     * @param poolId Filter records by pool ids
     * @param poolName Filter records by pool names
     * @param country Filter records by country
     * @param mnoId Filter records by MNO ID
     * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - pool_id,  - pool_name,  - country,  - mno_id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<POOLINFO>>;
    public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<POOLINFO>>>;
    public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<POOLINFO>>>;
    public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (poolId) {
            poolId.forEach((element) => {
                queryParameters = queryParameters.append('pool_id', <any>element);
            })
        }
        if (poolName) {
            poolName.forEach((element) => {
                queryParameters = queryParameters.append('pool_name', <any>element);
            })
        }
        if (country) {
            country.forEach((element) => {
                queryParameters = queryParameters.append('country', <any>element);
            })
        }
        if (mnoId) {
            mnoId.forEach((element) => {
                queryParameters = queryParameters.append('mno_id', <any>element);
            })
        }
        if (sortString !== undefined) {
            queryParameters = queryParameters.set('sort_string', <any>sortString);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<POOLINFO>>(`${this.basePath}/pools`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Number of pools getting operation. This is the operation to get a number of pools managed by the authenticated account
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public poolsHead(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public poolsHead(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public poolsHead(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public poolsHead(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.head<any>(`${this.basePath}/pools`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get detailed information about the pool
     * @param poolId Id of requested pool
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public poolsPoolIdGet(poolId: number, observe?: 'body', reportProgress?: boolean): Observable<POOLINFO>;
    public poolsPoolIdGet(poolId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POOLINFO>>;
    public poolsPoolIdGet(poolId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POOLINFO>>;
    public poolsPoolIdGet(poolId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (poolId === null || poolId === undefined) {
            throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<POOLINFO>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update subset of pool information
     * @param poolId Id of requested pool
     * @param poolObjectSubset 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public poolsPoolIdPost(poolId: number, poolObjectSubset: PoolObjectSubset, observe?: 'body', reportProgress?: boolean): Observable<POOLINFO>;
    public poolsPoolIdPost(poolId: number, poolObjectSubset: PoolObjectSubset, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POOLINFO>>;
    public poolsPoolIdPost(poolId: number, poolObjectSubset: PoolObjectSubset, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POOLINFO>>;
    public poolsPoolIdPost(poolId: number, poolObjectSubset: PoolObjectSubset, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (poolId === null || poolId === undefined) {
            throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdPost.');
        }
        if (poolObjectSubset === null || poolObjectSubset === undefined) {
            throw new Error('Required parameter poolObjectSubset was null or undefined when calling poolsPoolIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<POOLINFO>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}`,
            poolObjectSubset,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get a list of profiles from a specified pool
     * @param poolId Id of requested pool
     * @param status Filter for status of profiles
     * @param searchString String to search for cards with specific iccid or msisdn or imsi in the pool. Sort order from old records to new ones
     * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - pool_id,  - iccid,  - imsi  - msisdn  - status
     * @param offset An offset for a list (required for pagination)
     * @param limit A maximum number of entries returned by the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public poolsPoolIdProfilesGet(poolId: number, status?: string, searchString?: string, sortString?: string, offset?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SMDPPROFILE>>;
    public poolsPoolIdProfilesGet(poolId: number, status?: string, searchString?: string, sortString?: string, offset?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SMDPPROFILE>>>;
    public poolsPoolIdProfilesGet(poolId: number, status?: string, searchString?: string, sortString?: string, offset?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SMDPPROFILE>>>;
    public poolsPoolIdProfilesGet(poolId: number, status?: string, searchString?: string, sortString?: string, offset?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (poolId === null || poolId === undefined) {
            throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdProfilesGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (status !== undefined) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (searchString !== undefined) {
            queryParameters = queryParameters.set('search_string', <any>searchString);
        }
        if (sortString !== undefined) {
            queryParameters = queryParameters.set('sort_string', <any>sortString);
        }
        if (offset !== undefined) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<SMDPPROFILE>>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}/profiles`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Number of profiles getting operation. This is the operation to get a number of profiles contained in the pool
     * @param poolId Id of requested pool
     * @param searchString String to search for cards with specific iccid or msisdn or imsi in the pool
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public poolsPoolIdProfilesHead(poolId: number, searchString?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public poolsPoolIdProfilesHead(poolId: number, searchString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public poolsPoolIdProfilesHead(poolId: number, searchString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public poolsPoolIdProfilesHead(poolId: number, searchString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (poolId === null || poolId === undefined) {
            throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdProfilesHead.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (searchString !== undefined) {
            queryParameters = queryParameters.set('search_string', <any>searchString);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.head<any>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}/profiles`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Move subscriptions to the selected pool
     * @param poolId ID of the target subscription pool
     * @param iccids The list containing the ICCID of subscriptions to be moved to the target pool
     * @param sourceId ID of the source subscription pool containing subscriptions to be moved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public poolsPoolIdProfilesPut(poolId: number, iccids: Array<string>, sourceId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<RESPONSEITEM>>;
    public poolsPoolIdProfilesPut(poolId: number, iccids: Array<string>, sourceId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RESPONSEITEM>>>;
    public poolsPoolIdProfilesPut(poolId: number, iccids: Array<string>, sourceId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RESPONSEITEM>>>;
    public poolsPoolIdProfilesPut(poolId: number, iccids: Array<string>, sourceId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (poolId === null || poolId === undefined) {
            throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdProfilesPut.');
        }
        if (iccids === null || iccids === undefined) {
            throw new Error('Required parameter iccids was null or undefined when calling poolsPoolIdProfilesPut.');
        }
        if (sourceId === null || sourceId === undefined) {
            throw new Error('Required parameter sourceId was null or undefined when calling poolsPoolIdProfilesPut.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sourceId !== undefined) {
            queryParameters = queryParameters.set('source_id', <any>sourceId);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<Array<RESPONSEITEM>>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}/profiles`,
            iccids,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Register new pool in the database. Account should be granted with special permissions for this procedure
     * @param poolObject 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public poolsPut(poolObject: POOLINFO, observe?: 'body', reportProgress?: boolean): Observable<POOLINFO>;
    public poolsPut(poolObject: POOLINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POOLINFO>>;
    public poolsPut(poolObject: POOLINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POOLINFO>>;
    public poolsPut(poolObject: POOLINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (poolObject === null || poolObject === undefined) {
            throw new Error('Required parameter poolObject was null or undefined when calling poolsPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<POOLINFO>(`${this.basePath}/pools`,
            poolObject,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api/pools.service.ts